import VueTypes from 'vue-types';
import { VTStock } from '@/mikan/_shared/types/vueTypes/stock';
import { VTSpot } from '@/mikan/_shared/types/vueTypes/spot';
import { VTInstantBooking, VTRequestedBooking } from '@/mikan/_shared/types/vueTypes/booking';

export const VTRestaurantId = VueTypes.string;
export const VTRestaurant = VueTypes.shape({
  id: VTRestaurantId.isRequired,
  stocks: VueTypes.arrayOf(VTStock).isRequired,
  closingDates: VueTypes.arrayOf(VueTypes.string).isRequired,
  instantBookings: VueTypes.arrayOf(VTInstantBooking).isRequired,
  requestedBookings: VueTypes.arrayOf(VTRequestedBooking).isRequired,
  spots: VueTypes.arrayOf(VTSpot).isRequired,
  totalPages: VueTypes.integer,
});
